import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PayState } from '../reducers/pay.reducer';

export const selectPayState = createFeatureSelector<PayState>('pay');

// Customer selectors
export const selectCustomerData = createSelector(selectPayState,(state) => state.customerData);
export const selectCustomerLoading = createSelector(selectPayState,(state) => state.customerLoading);
export const selectCustomerError = createSelector(selectPayState,(state) => state.customerError);

// Detailed customer selectors
export const selectCustomerMerchId = createSelector(selectCustomerData,(customerData) => customerData?.customerMerchId);

// Payment selectors
export const selectPaymentState = createSelector(selectPayState, (state) => state.payment);
export const selectPaymentLoading = createSelector(selectPayState, (state) => state.loading);
export const selectPaymentError = createSelector(selectPaymentState, (state) => state.error);
export const selectPaymentResponse = createSelector(selectPaymentState, (state) => state.response);
